import type { ReportDtoT } from '@mathflat/domain/@entities/(Content)/Report'
import { uniqueId } from 'lodash-es'
import { makeAutoObservable } from 'mobx'

export class ReportModelV2 {
  /**
   * 커스텀 보고서에만 있는 필드들
   */
  id: ReportDtoT.GetReportCustomV2Response['id']
  pdfStatus: ReportDtoT.GetReportCustomV2Response['pdfStatus']
  sharedToParent: ReportDtoT.GetReportCustomV2Response['sharedToParent']
  metric: ReportDtoT.GetReportCustomV2Response['metric']

  /**
   * 공통 필드들
   */
  type:
    | ReportDtoT.GetReportRealTimeV2Response['type']
    | ReportDtoT.GetReportCustomV2Response['type']
  title: ReportDtoT.GetReportRealTimeV2Response['title']
  studentId: ReportDtoT.GetReportRealTimeV2Response['studentId']
  studentName: ReportDtoT.GetReportRealTimeV2Response['studentName']
  year: ReportDtoT.GetReportRealTimeV2Response['year']
  month: ReportDtoT.GetReportRealTimeV2Response['month']
  startDate: ReportDtoT.GetReportRealTimeV2Response['startDate']
  endDate: ReportDtoT.GetReportRealTimeV2Response['endDate']
  createdAt: ReportDtoT.GetReportRealTimeV2Response['createdAt']
  chapters: ReportDtoT.GetReportRealTimeV2Response['chapters']

  constructor(data: ReportDtoT.GetReportRealTimeV2Response | ReportDtoT.GetReportCustomV2Response) {
    makeAutoObservable(this)

    if (data.type === 'REAL_TIME') {
      this.id = Number(uniqueId())
      this.pdfStatus = 'SUCCESS'
      this.sharedToParent = false
      this.metric = {
        scoringCount: null,
        rank: null,
        correctRate: null,
      }
    } else {
      this.id = data.id
      this.pdfStatus = data.pdfStatus
      this.sharedToParent = data.sharedToParent
      this.metric = data.metric
    }

    this.type = data.type
    this.title = data.title
    this.studentId = data.studentId
    this.studentName = data.studentName
    this.year = data.year
    this.month = data.month
    this.startDate = data.startDate
    this.endDate = data.endDate
    this.createdAt = data.createdAt
    this.chapters = data.chapters
  }

  get isDisabled() {
    if (this.type === 'REAL_TIME') {
      return this.metric.scoringCount === null || this.metric.scoringCount === 0
    }

    return this.pdfStatus !== 'SUCCESS'
  }

  setMetric(metric: ReportDtoT.GetReportCustomV2Response['metric']) {
    this.metric = metric
  }
}
